<template>
    <div>
        {{ msg }}
    </div>
</template>

<script>
export default {
    name: "Shelf",
    data() {
        return {
            msg: 'Store Here',
        }
    },
}
</script>

<style scoped>

</style>
